import React from 'react'
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import PathMap from '@/components/lib/PathMap';
import QRCode from 'react-qr-code';
import useSettings from '@/hooks/useSettings';
import { FaDownload } from 'react-icons/fa6';

const GeneralQRCode = () => {
    const { settings } = useSettings();

    console.log(settings)

    function downloadQrcodeaspng(){
        const svgElement = document.getElementById("general-qr-code");
        if (!svgElement) return;

        // Clone the SVG element and clean its style attribute so that browser-specific padding/margins do not shift or distort the rendering
        const clonedSvg = svgElement.cloneNode(true);
        clonedSvg.removeAttribute("style");

        const svgString = new XMLSerializer().serializeToString(clonedSvg);
        const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
        const URL = window.URL || window.webkitURL || window;
        const blobURL = URL.createObjectURL(svgBlob);

        const image = new Image();
        image.onload = () => {
            const canvas = document.createElement("canvas");
            const size = 1024;
            canvas.width = size;
            canvas.height = size;
            const context = canvas.getContext("2d");
            
            if (context) {
                // Draw a solid white background
                context.fillStyle = "#ffffff";
                context.fillRect(0, 0, size, size);
                
                // Centered and slightly scaled down to fit perfectly with a nice margin
                const margin = 128;
                const qrSize = size - 2 * margin;
                context.drawImage(image, margin, margin, qrSize, qrSize);
                
                const pngURL = canvas.toDataURL("image/png");
                const downloadLink = document.createElement("a");
                downloadLink.href = pngURL;
                downloadLink.download = `${settings?.restaurant?.name || 'restaurant'}-qr-code.png`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
            URL.revokeObjectURL(blobURL);
        };
        image.src = blobURL;
    }

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
    >
      <div className="container">
        <div className='flex justify-between items-center'>
          <PathMap 
            pageName={{ title: "General QR code" }}
            paths={[
              // { name: "Home", path: "/" },
              // { name: "Online Ordering", path: "/online-ordering" },
              { name: "QR Code Ordering", path: "/onlineordering/qr-code/general" },
              { name: "QR Code" },
            ]}
          />
        </div>
        <div className=" flex flex-col items-center justify-center mt-10">
            <QRCode
                id="general-qr-code"
                size={256}
                style={{ height: "auto", width: "332px", padding: '33px', background: 'white', cursor: 'pointer' }}
                value={`${settings?.restaurant?.website}/menu?source=qr_code`}
                viewBox={`0 0 256 256`}
            />
            <div onClick={downloadQrcodeaspng} className=" w-[332px] py-1 flex items-center justify-center gap-2 mt-4 cursor-pointer bg-color6 rounded-md">
            <span>Download</span>
            <span><FaDownload /></span>
        </div>
        </div>
        

      </div>
    </Layout2>
  )
}

export default GeneralQRCode